import { ALERT_TYPE, ClientHostType, GOP_BIZCODE, HTTP_STATUS, ResponseType } from '@/types';
import { gopController, httpController } from './controller';
import { objectToQueryString, parseQueryString, localeMixin } from '@/utils/tools';
import service from './service';
import { useStore } from '@/store';
import { getQueryStringByName, isWeChat, isDaily } from '@/utils';
import { clone, isObject } from 'lodash';
import { Toast } from '@/components/Toast';
import { AxiosResponse } from 'axios';
import { getIntl } from '@/locales';
import { apiItraceTracker } from '@/utils/itrace/report';

let requestRetryCount = 10;
// 请求配置
export const requestConfig = (config: any) => {
  const { baseObj, device } = useStore.getState();
  const { sid } = baseObj.user;
  config.headers = {
    'x-hng': localeMixin(),
    'EagleEye-UserData': localeMixin(),
    cinemaLinkId: getQueryStringByName('cinemaId') || baseObj.cinema.cinemaLinkId || baseObj.cinema.linkid,
    channelCode: getQueryStringByName('wapid') || baseObj.wapid,
    appKey: '500000',
  };

  if (!isObject(config.data)) {
    config.data = Object.fromEntries(new URLSearchParams(config.data).entries());
  }

  const needAddDeviceList = [
    'gop.alipic.icirena.own.order.payOrder',
    'gop.alipic.icirena.own.order.createTicketOrder',
    'gop.alipic.icirena.own.order.createGoodsOrder',
  ];
  if (needAddDeviceList.includes(config.api)) {
    const ext = {
      device,
    };
    config.data = {
      ...config.data,
      ext: JSON.stringify(ext),
    };
  }

  config.data = {
    ...config.data,
    __cv__: 'WEBSITE',
  };

  const needAddPlatformList = [
    'gop.alipic.icirena.own.pay.getPayPrivilegeInfo',
    'gop.alipic.icirena.own.order.getOrderDetail',
    'gop.alipic.icirena.own.pay.getPayMethod',
  ];

  if (needAddPlatformList.includes(config.api)) {
    // if (isMpay()) {
    //   config.data.platform = 'MPayMiniProgram';
    // }
    if (isWeChat()) {
      config.data.platform = 'wechat';
    }
    // if(isTFB()){
    //   config.data.platform = 'TaifungPayMiniProgram';
    // }
  }

  let curData = clone(config.data);
  curData = {
    empCode: '',
    leaseCode: '',
    cinemaLinkId: getQueryStringByName('cinemaId') || baseObj.cinema.cinemaLinkId || baseObj.cinema.linkid,
    channelCode: getQueryStringByName('wapid') || baseObj.wapid,
    larkSid: sid,
    version: 'H5',
    appVersion: 'H5_5.0',
    // apiVersion: '1.0',//合并问题:银河灰度的参数，master添加会导致接口报错，暂时注释掉
    ...curData,
  };

  config.data = curData;
  const { api, params, data, headers, type = 'POST' } = isDaily() ? httpController(config) : gopController(config);
  config.url = api;
  config.params = params;
  config.data = objectToQueryString(data);
  config.headers = headers;
  config.method = type;
  return config;
};

/**
 * @description 存储 Sid
 * @param res
 */
function updateSid(res: ResponseType) {
  const { baseObj } = useStore.getState();
  baseObj.user.sid = res.result.bizValue.sid;
  baseObj.user.tid = res.result.bizValue.tid;
  baseObj.user.account = res.result.bizValue.account;
  useStore.setState({
    baseObj,
  });
}

/**
 * @description 重新请求数据
 * @param response
 * @returns
 */
export const refreshToken = async (response: { config: any }) => {
  const { baseObj } = useStore.getState();
  if (requestRetryCount <= 0) return Promise.reject(response);
  try {
    let refreshSid: any = {};
    if (!baseObj?.user?.tid) {
      refreshSid = await service.authGuestLogin();
    } else {
      refreshSid = await service.getSid();
    }
    if (refreshSid?.result?.bizCode === HTTP_STATUS.SUCCESS) {
      updateSid(refreshSid);
      const newConfig = response.config;
      newConfig.data = parseQueryString(newConfig.data);
      newConfig.data.larkSid = refreshSid?.result.bizValue.sid;
      // console.log('log_[newConfig]==>', newConfig);
      const result = await service.axios(newConfig);
      // console.log('log_[result]==>', result);
      return result;
    } else {
      // 请求次数减1
      requestRetryCount -= 1;
      return Promise.reject(refreshSid);
    }
  } catch (error) {
    // 处理刷新Token失败的逻辑
    return Promise.reject(error);
  }
};

/**
 * @description 重新登录
 */
export const reloadLogin = async () => {
  const { baseObj, channel } = useStore.getState();
  if (channel === ClientHostType.galaxy) {
    await service.authGuestLogin().then(async (res) => {
      if (res.result.bizValue) {
        await useStore.setState({
          baseObj: {
            ...baseObj,
            user: res.result.bizValue,
          },
        });
      }
    });
  } else {
    Toast({
      type: ALERT_TYPE.CONFIRM,
      content: '登录失效',
      confirm: async () => {
        await useStore.setState({
          baseObj: {
            ...baseObj,
            user: {},
          },
        });
        window.location.href = `//${location.host}/${location.search}`;
      },
    });
  }
};

// const filterApi = ['gop.alipic.icirena.own.pay.getPayPrivilegeInfo', 'gop.alipic.icirena.own.seat.lockSeats'];

// function isResponseTip(response) {
//   try {
//     const isSomeApi = filterApi.some((item) => item === response?.config?.api);
//     return isSomeApi;
//   } catch (error) {
//     return false;
//   }
// }

// 响应配置
export const responseConfig = async (res: AxiosResponse<ResponseType>): Promise<any> => {
  const intl = getIntl();
  // 取消全局提示,需要做额外处理的才加
  let filterCode = ['ORDER_HAS_CLOSE', 'PROMOCARD_CAL_ERROR', '10000', '1010'];
  // 日常环境处理
  const response = res;
  // {
  //   data: {
  //     result: isDaily() ? res.data.data : res.data.result,
  //   },
  // };
  try {
    // 正常数据返回
    if (response && response?.data) {
      // 返回请求结果
      if (response?.data?.result) {
        // 日常环境处理
        if (isDaily()) {
          response.data.result = res.data.data;
        }
        const responseCode = response?.data.result?.bizCode;
        if (responseCode === HTTP_STATUS.SUCCESS) {
          return response?.data;
        } else if (responseCode === GOP_BIZCODE.LOGINEXPIREND) {
          return refreshToken(response);
        } else if (responseCode === GOP_BIZCODE.LOGINTIMEOUT) {
          return reloadLogin();
        } else {
          if (filterCode.includes(responseCode)) {
            return response?.data;
          }
          apiItraceTracker.report(response);
          Toast({
            type: ALERT_TYPE.CONFIRM,
            content:
              response?.data?.result?.bizAlertMsg ||
              intl.formatMessage({
                id: 'iWeb.components.default.NetworkException',
                defaultMessage: '抱歉网络异常，稍后再试',
              }),
          });
        }
      } else if (response.data?.data && typeof response.data?.data === 'string') {
        // 返回字符串
        response.data.data = JSON.parse(response.data.data || '');
      } else {
        apiItraceTracker.report(response);
        await Toast({
          type: ALERT_TYPE.CONFIRM,
          content: intl.formatMessage({
            id: 'iWeb.components.default.NetworkException',
            defaultMessage: '抱歉网络异常，稍后再试',
          }),
        });
      }
    } else if ((response as any)?.error_response) {
      // 处理网络异常问题，结构为error_response
      apiItraceTracker.report(response);
      await Toast({
        type: ALERT_TYPE.CONFIRM,
        content: intl.formatMessage({
          id: 'iWeb.components.default.NetworkException',
          defaultMessage: '抱歉网络异常，稍后再试',
        }),
      });
    } else {
      await Toast({
        type: ALERT_TYPE.CONFIRM,
        content: intl.formatMessage({
          id: 'iWeb.components.default.NetworkException',
          defaultMessage: '抱歉网络异常，稍后再试',
        }),
      });
    }
  } catch (error) {
    // 处理响应失败的逻辑
    return Promise.reject(error);
  }
  return response?.data;
};
